const initial = {
  showCartPopup: false,
  showWislistPopup: false,
  selectedSizeCode: '',
  selectedSizeName: '',
  selectedSizeStockLevel: '',
  discountPrice: '',
  originalPrice: '',
  discountPercentage: '',
  addedToCart: false,
  wishlistStatus: '',
  hideMinicart: '',
  isProductRemoved: false,
  addedToCartMembership: false,
  // B2C: last add-to-bag was fulfilled by a different seller than the one shown.
  sellerChanged: false
};

export default function Popup(state = initial, action) {
  switch (action.type) {
    case 'SHOW_CART_POPUP':
      return {
        ...state,
        showCartPopup: action.showCartPopup,
        addedToCart: true
      };
    
    case 'SET_SELLER_CHANGED':
      return {
        ...state,
        sellerChanged: action.sellerChanged
      };

    case 'SHOW_CART_MEMBERSHIP':
      return {
        ...state,
        addedToCartMembership: true
      };

    case 'SHOW_WISHLIST_POPUP':
      return {
        ...state,
        showWislistPopup: action.showWishlistPopup,
        wishlistStatus: action.wishlistStatus,
        isProductRemoved: action.isProductRemoved
      };

    case 'QUICKVIEW_SELECT_SIZE':
      let { discountPrice, originalPrice } = action;
      let sp = parseInt(discountPrice.replace(/\D/g, ''));
      let cp = parseInt(originalPrice.replace(/\D/g, ''));
      let discountPercent;
      let discount;
      if (sp !== cp) {
        discountPercent = Math.round(((cp - sp) / cp) * 100);
        discount = `${discountPercent}% off`;
      }
      return {
        ...state,
        selectedSizeName: action.selectedSizeName,
        selectedSizeCode: action.selectedSizeCode,
        selectedSizeStockLevel: action.selectedSizeStockLevel,
        discountPrice: action.discountPrice,
        originalPrice: action.originalPrice,
        discountPercentage: discount
      };

    case 'RESET_SIZE_SELECTED':
      return {
        ...state,
        selectedSizeName: '',
        selectedSizeCode: '',
        selectedSizeStockLevel: '',
        discountPrice: '',
        originalPrice: ''
      };

    case 'RESET_CART_ITEM':
      return {
        ...state,
        addedToCart: false,
        sellerChanged: false
      };

    case 'HIDE_MINICART':
      return {
        ...state,
        showCartPopup: false,
        hideMinicart: true
      };

    case 'CLOSE_ALL_POPUP':
      return {
        ...state,
        showCartPopup: false,
        showWislistPopup: false
      };
    default:
      return state;
  }
}
